import React from 'react';
type AppIconProps = React.SVGProps<SVGSVGElement>;
function AppIcon({
  className,
  ...props
}: AppIconProps) {
  return <svg aria-hidden="true" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={props.strokeWidth ?? 2} strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-1" data-mp="26yvlow4yhkzj">
      <circle cx="12" cy="12" r="9" data-id="element-2" data-mp="2kpsbygbetq3f" />
      <path d="m8.5 12 2.3 2.3L15.8 9" data-id="element-3" data-mp="2kqjzr4yrmjj5" />
    </svg>;
}
export const ActivityIcon = AppIcon;
export const AwardIcon = AppIcon;
export const BadgeCheckIcon = AppIcon;
export const BookOpenIcon = AppIcon;
export const CalendarIcon = AppIcon;
export const CheckCircle2Icon = AppIcon;
export const CheckIcon = AppIcon;
export const ChevronDownIcon = AppIcon;
export const CircleIcon = AppIcon;
export const ClipboardIcon = AppIcon;
export const Clock3Icon = AppIcon;
export const CreditCardIcon = AppIcon;
export const DumbbellIcon = AppIcon;
export const GamepadIcon = AppIcon;
export const GiftIcon = AppIcon;
export const Globe2Icon = AppIcon;
export const InstagramIcon = AppIcon;
export const LockKeyholeIcon = AppIcon;
export const MailIcon = AppIcon;
export const MessageCircleIcon = AppIcon;
export const ShieldCheckIcon = AppIcon;
export const TrendingUpIcon = AppIcon;
export const TrophyIcon = AppIcon;
export const UserIcon = AppIcon;
export const UsersIcon = AppIcon;
export const WavesIcon = AppIcon;
export const XCircleIcon = AppIcon;
export const XIcon = AppIcon;
export const ZapIcon = AppIcon;